import { render, staticRenderFns } from "./LabelCornerTopLeftIcon.vue?vue&type=template&id=206fd465&"
import script from "./LabelCornerTopLeftIcon.vue?vue&type=script&lang=js&"
export * from "./LabelCornerTopLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports